// extracted by mini-css-extract-plugin
export default {"zero":"Cell_zero__vHexB","placeHolderShimmer":"Cell_placeHolderShimmer__TFs2O"};